import React, { forwardRef } from 'react';

import { ComponentIconProps } from '../types';

const AccordionExpandIcon = forwardRef<SVGSVGElement, ComponentIconProps>(
  ({ className, size = 10 }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="currentColor"
      aria-hidden="true"
      data-testid="AccordionExpandIcon"
      style={{ flex: 'none' }}
    >
      <path d="M5.94 5L3 8C2.86303 8.28681 2.9217 8.62881 3.14645 8.85356C3.37119 9.0783 3.7132 9.13698 4 9L7.5 5.5C7.79246 5.20718 7.79246 4.73282 7.5 4.44L4 1C3.7132 0.863026 3.37119 0.921704 3.14645 1.14645C2.9217 1.37119 2.86303 1.7132 3 2L5.94 5Z" />
    </svg>
  ),
);

AccordionExpandIcon.displayName = 'AccordionExpandIcon';

export default AccordionExpandIcon;
